var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { DottedChevronDownIconGlyph } from '@shapeable/icons';
export var ScrollViewDefaultProps = {
  fadeSize: '60px'
};
// -------- Styles ---------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: hidden;\n    position: relative;\n    display: flex;\n  "], ["\n    overflow: hidden;\n    position: relative;\n    display: flex;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-bottom: ", ";\n  "])), theme.UNIT(10))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FadeStyles = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 50;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 10px);\n  background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n\n  ", "\n"], ["\n  position: absolute;\n  z-index: 50;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 10px);\n  background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n\n  ", "\n"])), function (props) {
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: ", ";\n  "], ["\n    height: ", ";\n  "])), props.fadeSize);
});
var ArrowStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    z-index: 100;\n  "], ["\n    z-index: 100;\n  "])))
});
// -------- Components ---------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Content: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Fade: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  Arrow: styled(Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ArrowStyles)
};
export var ScrollView = function (props) {
  var className = props.className,
    fadeSize = props.fadeSize,
    children = props.children;
  var scrollRef = useRef();
  var sizeRef = useRef();
  return React.createElement(My.Container, {
    fadeSize: fadeSize,
    className: className
  }, React.createElement(My.Body, {
    ref: scrollRef,
    fadeSize: fadeSize
  }, React.createElement(My.Content, {
    ref: sizeRef
  }, children)), React.createElement(My.Fade, {
    fadeSize: fadeSize
  }, React.createElement(My.Arrow, {
    size: 18,
    color: "textSubtle"
  }, React.createElement(DottedChevronDownIconGlyph, null))));
};
ScrollView.defaultProps = ScrollViewDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;